import appInfo from "@common/appInfo";
import { getCdnBaseUrl } from "@common/controls/Video/Bunny/lib";
import { type Media } from "@common/declarations";
import { isUuid } from "@common/lib/misc";
import { parseQueryString, updateQueryString } from "@common/lib/url";
import { trimStart } from "lodash";

export const setPreviewImageWidth = (url: string | null | undefined, width?: number): string => {
  if (!url) return "";

  if (width && url.startsWith("https://images.unsplash.com")) {
    const qs = parseQueryString(url);
    qs.w = width;
    return updateQueryString(url, qs);
  }

  return url;
};

export const getMediaUrl = (sourceKey: Media.Source, sourceId: string, width?: number): string => {
  switch (sourceKey) {
    case "AwsS3": {
      if (sourceId.startsWith("http")) return sourceId;

      const parts = trimStart(sourceId, "/").split("/");
      if (isUuid(parts[0])) {
        return `${appInfo.awsBaseUrl}${sourceId}`;
      }
      return `${appInfo.awsBaseUrl}/${appInfo.system.id.toLowerCase()}${sourceId}`;
    }
    case "Bunny":
      return `${getCdnBaseUrl()}/${sourceId}/playlist.m3u8`;
    default:
      return setPreviewImageWidth(sourceId, width);
  }
};
